import CrudTab from 'react/containers/pages/CrudTab';

class GroupPermissions extends CrudTab {

  componentDidMount() {
    const { updateTitle, tab: { key } } = this.props;
    this.router = new App.Routers.GroupPermissions();
    this.router.show();
    updateTitle({
      key,
      title: Monet.I18n.getResourcesByKey('groupPermission.userinterface.description')
    });
  }

}

export default GroupPermissions;
